"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onResponseFulfilled = onResponseFulfilled;
exports.onResponseRejected = onResponseRejected;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _elementUi = require("element-ui");

var _auth = require("../../organizationLibs/vueSsoSdk/auth");

var _host = require("../../organizationLibs/vueSsoSdk/util/host");

/**
 * 从错误中解析出 level 和 message
 *
 * @param {Error} error
 * @returns {{level: string?, message: string?}}
 */
function parseError(error) {
  try {
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$data = _error$response.data;
    _error$response$data = _error$response$data === void 0 ? {} : _error$response$data;
    var _error$response$data$ = _error$response$data.level,
        level = _error$response$data$ === void 0 ? 'system' : _error$response$data$,
        _error$response$data$2 = _error$response$data.message,
        message = _error$response$data$2 === void 0 ? '服务器内部错误！' : _error$response$data$2;
    return {
      level: level,
      message: message
    };
  } catch (e) {
    return {};
  }
}
/**
 * axios 响应前置处理器
 *
 * @param {object?} response
 * @returns {*}
 */


function onResponseFulfilled(response) {
  if (!response) {
    return response;
  }

  if (response.status === 204) {
    return undefined;
  } // No Content


  return response.data;
}
/**
 * axios 响应错误处理器
 *
 * @param {Error?} error
 */


function onResponseRejected(_x) {
  return _onResponseRejected.apply(this, arguments);
}

function _onResponseRejected() {
  _onResponseRejected = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
    var _ref,
        _ref$errorHandling,
        errorHandling,
        level,
        message,
        _parseError,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$errorHandling = _ref.errorHandling, errorHandling = _ref$errorHandling === void 0 ? true : _ref$errorHandling;
            console.error(JSON.stringify(error)); // for debug

            if (error.response) {
              _context.next = 5;
              break;
            }

            console.error('axios 返回的错误中不包含 response');
            throw error;

          case 5:
            _context.t0 = error.response.status;
            _context.next = _context.t0 === 401 ? 8 : _context.t0 === 403 ? 11 : 14;
            break;

          case 8:
            _context.next = 10;
            return (0, _auth.onUnauthorizedError)(error, _elementUi.Message.error);

          case 10:
            return _context.abrupt("break", 23);

          case 11:
            _context.next = 13;
            return (0, _host.toLoginPage)();

          case 13:
            return _context.abrupt("break", 23);

          case 14:
            _parseError = parseError(error);
            level = _parseError.level;
            message = _parseError.message;

            if (!(errorHandling && level === 'system')) {
              _context.next = 21;
              break;
            }

            _elementUi.Message.error(message);

            _context.next = 22;
            break;

          case 21:
            throw new Error(message);

          case 22:
            return _context.abrupt("break", 23);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _onResponseRejected.apply(this, arguments);
}